"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartDefinition = exports.cartDefinition = {
    "isCompact": false,
    "dispatchDate": null,
    "isAnyProductOutOfStock": false,
    "minOrderPriceForFreeDelivery": null,
    "minOrderPriceForPossibleFreeDelivery": null,
    "minOrderPriceForFreeProducts": null,
    "deliveryTypes": [],
    "paymentTypes": [],
    "allowedDeliveryPayments": [],
    "giftItems": [],
    "selectedFreeProducts": [],
    "anonymous": false,
    "termsUrl": null,
    "isLibrary": false,
    "isConfidant": false,
    "totalConfidantCommission": null,
    "freeProducts": [],
    "canPickMultipleFreeProductsPerCampaign": false,
    "accountNumber": null,
    "accountPin": null,
    "id": 0,
    "miniCartMaxItems": 2147483647,
    "items": [],
    // This is actually weird - itemAmounts is not used nowhere but on add-to-cart.js, but it can be replaced by items array, it contains all necessary values
    "itemAmounts": [],
    "totalPrice": {
        "percentageDiscount": 0,
        "nominalDiscount": 0,
        "finalPriceWithoutVat": 0,
        "standardPrice": 0,
        "finalPrice": 0
    },
    "totalProductsPrice": {
        "percentageDiscount": 0,
        "nominalDiscount": 0,
        "finalPriceWithoutVat": 0,
        "standardPrice": 0,
        "finalPrice": 0
    },
    "totalVat": 0,
    "dispatchSeparately": false,
    "note": null,
    "processingOrdersPrice": 0,
    "minPriceForDispatch": 0,
    "maxAmountPerItem": null,
    "canCreateOrder": false,
    "pendingAnonymousPaymentUrl": null,
    "pendingAnonymousPaymentTransactionId": null,
    "canSeeRabat": false,
    "canChangeCart": false,
    "dispatchWarning": false,
    "offlineMode": false,
    "offlineModeMessage": null,
    "sendOrderDisabledReason": "",
    "showStockAmountSeparately": false,
    "notifyMessages": [],
    "amountAvailableLimit": 0,
    "coupon": null,
    "voucher": null,
    "deliveryTypeId": null,
    "phoneCountryCode": '420',
    "deliveryPrice": null,
    "paymentTypeId": null,
    "paymentType": null,
    "pickupPlaceId": null,
    "pickupPlace": null,
    "financialInstitutionId": null,
    "financialInstitution": null,
    "hasShoppingConditionsConsent": false,
    "hasCustomerReviewConsent": false
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/cart-initial-state.js
// module id = 568
// module chunks = 0 2